import { ADD_NOTIFICATION, CLEAR_NOTIFICATIONS } from './types';

export const addNotification = (notification) => ({
  type: ADD_NOTIFICATION,
  payload: notification,
});

export const clearNotifications = (resumeId) => ({
  type: CLEAR_NOTIFICATIONS,
  payload: resumeId,
});

